// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"8985":"484a0767ec8b878f","9729":"75abe6a9e93f46a0"}[chunkId] + ".css";
};